export default class RouterService {
    _router;
    constructor(router) {
        this._router = router;
    }
    get name() {
        return this._router.currentRoute.name;
    }
    get query() {
        return this._router.currentRoute.query || {};
    }
    get params() {
        return this._router.currentRoute.params || {};
    }
    /**
     * Trigger a route change on the files app
     *
     * @param path the url path, eg: '/trashbin?dir=/Deleted'
     * @param replace replace the current history
     * @see https://router.vuejs.org/guide/essentials/navigation.html#navigate-to-a-different-location
     */
    goTo(path, replace = false) {
        return this._router.push({
            path,
            replace,
        });
    }
    /**
     * Trigger a route change on the files App
     *
     * @param name the route name
     * @param params the route parameters
     * @param query the url query parameters
     * @param replace replace the current history
     * @see https://router.vuejs.org/guide/essentials/navigation.html#navigate-to-a-different-location
     */
    goToRoute(name, params, query, replace) {
        return this._router.push({
            name,
            query,
            params,
            replace,
        });
    }
}
